import gql from 'graphql-tag';

import type { UpdateContactTrainingInfoRequestDto } from '@cobliteam/common-types';

import type { MutationUpdateContactTrainingArgs } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

class GraphQLCrmRequester {
  public updateContactTrainings = async (userTrainings: UpdateContactTrainingInfoRequestDto): Promise<any> => {
    const input = {
      finishedVideos: userTrainings.finishedVideos,
      startedVideos: userTrainings.startedVideos,
    };

    return graphQLRequester.mutate<{ updateContactTrainings: UpdateContactTrainingInfoRequestDto }, MutationUpdateContactTrainingArgs>({
      mutation: gql`
        mutation Mutation($input: UpdateContactTrainingInfoInput!) {
          updateContactTraining(input: $input)
        }
      `,
      variables: {
        input: input,
      },
    });
  };
}

export default GraphQLCrmRequester;
